<div style="margin-bottom: 20px;">

    <div *ngFor="let sensorReadingType of sensorReadingTypes; let i = index;" class="reading-type">

        <div style="margin-bottom: 8px; text-align: right;">
            <button type="button" class="btn btn-sm btn-primary" (click)="exportStatsToCsv(i)">Export</button>
        </div>

        <p-table [columns]="statsTableCols" [value]="sensorStats[i]" dataKey="name" [scrollable]="true" scrollHeight="25em" [exportFunction]="exportCsv">

            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" [ngClass]="{'text-center': col.header != 'Sensor' && col.header != 'Last Reading' && col.header != 'Reading Type'}"
                        style="background-color: var(--kig-section-header-bg); flex: none;">
                        <span *ngIf="col.header == 'Sensor'">{{col.header}} ({{ sensorStats[i].length != 0 ? sensorStats[i].length - 1 : 0 }})</span>
                        <span *ngIf="col.header != 'Sensor'">{{col.header}}</span>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                <tr>
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        {{rowData.sensorName}}
                    </td>

                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{rowData.readingType }}
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;" class="text-center">
                        {{rowData.min }}
                    </td>

                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;" class="text-center">
                        {{rowData.max }}
                    </td>

                    <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;" class="text-center">
                        {{rowData.avg }}
                    </td>

                    <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;" class="text-center">
                        {{rowData.med }}
                    </td>

                    <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;" class="text-center">
                        {{rowData.count}}
                    </td>

                    <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;" class="text-center">
                        {{rowData.lastReadingValue }}
                    </td>

                    <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;" [ngStyle]="{'color': rowData.lastReadingDisplayColor }">
                        {{rowData.lastReadingDate | date: 'medium' }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <br>
    </div>

    <label style="font-size: 14px; margin-left: 10px; margin-right: 10px;">Last Reading Color Key:</label>
    <label style="font-size: 14px; margin-right: 10px; color: #64a70b"><i class="fa-solid fa-square"></i> Day,</label>
    <label style="font-size: 14px; margin-right: 10px; color: #dadb26"><i class="fa-solid fa-square"></i> Week,</label>
    <label style="font-size: 14px; margin-right: 10px; color: #ff9551"><i class="fa-solid fa-square"></i> Month,</label>
    <label style="font-size: 14px; margin-right: 10px; color: purple"><i class="fa-solid fa-square"></i> 6 Months,</label>
    <label style="font-size: 14px; margin-right: 10px; color: #f93232"><i class="fa-solid fa-square"></i> 6+ Months</label>

</div>